import type { TestTone } from "@mesketch/design-tokens";
import { createContext, useContext, type ReactNode } from "react";
import { toneOf } from "./content.js";

// Barva testu stránky (zadání 8.5.1: stránka nikdy v barvě jiného testu). Obal s `data-tone`
// přepne proměnné `--c-accent*` (design tokeny), kresby (pruhy, ukazatel postupu) berou tutéž
// barvu z kontextu.

const ToneContext = createContext<TestTone>("who");

export function useTone(): TestTone {
  return useContext(ToneContext);
}

export function Tone({ slug, children }: { readonly slug: string; readonly children: ReactNode }) {
  const tone = toneOf(slug);
  return (
    <ToneContext.Provider value={tone}>
      <div className="tone" data-tone={tone}>
        {children}
      </div>
    </ToneContext.Provider>
  );
}
